import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { ModalStatusComponent } from './ModalStatusComponent';
import { ModalHeaderComponent } from './ModalHeaderComponent';
import { getCoupon } from '../../../services/coupon/selector';
import { ModalOfferComponent } from './offer/ModalOfferComponent';
import { withLoadingCondition } from '../../loading/withLoadingCondition';
import { ModalMetaDataComponent } from './metadata/ModalMetaDataComponent';
import { getDiscountsByPartnerId } from '../../../services/discount/selector';

import './InterstitielModalComponent.scss';

class InterstitielModalComponent extends React.Component {
    renderModal = () => {
        const {
            i18nInterstitiel,
            REFUND,
            partner,
            success,
            fetching,
            coupon,
            discounts,
            forcedDiscount,
            noRedirectionFailure
        } = this.props;
        return (
            <div>
                <ModalOfferComponent partner={partner} coupon={coupon} discount={forcedDiscount} />
                <ModalStatusComponent
                    partner={partner}
                    coupon={coupon}
                    success={success}
                    i18n={i18nInterstitiel}
                    fetching={fetching}
                    noRedirectionFailure={noRedirectionFailure}
                />
                <ModalMetaDataComponent
                    partner={partner}
                    coupon={coupon}
                    i18n={i18nInterstitiel}
                    REFUND={REFUND}
                    discounts={discounts}
                />
            </div>
        );
    };

    render() {
        const { i18nInterstitiel, partner, urlRewritten, fetchingPartner } = this.props;
        return (
            <div className="modal-interstitiel">
                <ModalHeaderComponent
                    urlRewritten={urlRewritten}
                    partner={partner}
                    i18n={i18nInterstitiel}
                />
                {withLoadingCondition(fetchingPartner, this.renderModal)}
            </div>
        );
    }
}

InterstitielModalComponent.propTypes = {
    i18nInterstitiel: PropTypes.object.isRequired,
    success: PropTypes.bool,
    partnerId: PropTypes.string.isRequired,
    couponId: PropTypes.string,
    urlRewritten: PropTypes.string.isRequired,
    partner: PropTypes.object,
    noRedirectionFailure: PropTypes.bool
};

const mapStateToProps = (state, ownProps) => {
    return {
        i18nInterstitiel: state.i18n.page.INTERSTITIEL,
        REFUND: state.i18n.feature.partenaire.rembourse,
        partner: state.partner.partners[ownProps.partnerId] || null,
        discounts: getDiscountsByPartnerId(state, ownProps.partnerId),
        forcedDiscount: state.interstitiel.discount,
        fetchingPartner: state.partner.fetching,
        coupon: getCoupon(state, ownProps.partnerId, ownProps.couponId),
        fetching: state.interstitiel.fetching,
        urlRewritten: state.interstitiel.urlRewritten
    };
};

export default connect(mapStateToProps)(InterstitielModalComponent);



// WEBPACK FOOTER //
// ./src/components/pages/interstitiel/InterstitielModalComponent.js